import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const CustomCardContainer = styled(CustomCard)`
  .ant-card-body {
    margin: 16px;
    padding: 24px;
    background: ${({ theme }) => theme.colors.background1} !important;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    border: 1px solid ${({ theme }) => theme.colors.border};
  }
`;
